// FIN-1314: server-sent events out of a stream of text chunks — `event: x\ndata: {...}\n\n`,
// which may arrive cut anywhere. Each complete block becomes one { event, data } call.

export const parseBlock = (block) => {
  let event = 'message';
  const data = [];
  block.split('\n').forEach((line) => {
    if (line.startsWith('event:')) event = line.slice(6).trim();
    else if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
  });
  if (!data.length) return null;

  const text = data.join('\n');
  try {
    return { event, data: JSON.parse(text) };
  } catch (e) {
    return { event, data: text };
  }
};

export const createSseParser = (onEvent) => {
  let buffer = '';

  const emit = (block) => {
    const parsed = parseBlock(block);
    if (parsed) onEvent(parsed);
  };

  return {
    push(chunk) {
      buffer += chunk;
      let index = buffer.indexOf('\n\n');
      while (index !== -1) {
        emit(buffer.slice(0, index));
        buffer = buffer.slice(index + 2);
        index = buffer.indexOf('\n\n');
      }
    },
    end() {
      if (buffer.trim()) emit(buffer);
      buffer = '';
    },
  };
};
